<template>
  <el-dialog custom-class="dialog-modal-permission" :model-value="flagVisible" width="770px" :before-close="handleClose">
    <div class="modal-permission">
      <div class="modal-p-content text-that-needs-wrapping">
        <div class="modal-p-title">
          <span>Tech Specs rock when you can compare them!</span>
        </div>
        <div class="modal-p-desc">
          <p>For some customers it’s all about signal to noise! Or whatever is important to them. With comparative <b>Tech Specs</b> it’s easy and efficient for your customer to learn which of your products fits their need.</p>
          <p>If <b>Tech Specs</b> are not part of your subscription, contact <a href="mailto:sales@audiotestkitchen.com">sales@audiotestkitchen.com</a> to upgrade.</p>
        </div>
      </div>
      <div class="modal-p-img">
        <img src="@/assets/images/permissions/fea_tech.png" alt="" />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {
    flagVisible: Boolean
  },
  emits: ['closeModal'],
  data: function () {
    return {
    }
  },
  created: function () {
  },
  watch: {
  },
  methods: {
    handleClose: function () {
      this.$emit('closeModal')
    }
  }
}
</script>
